import { Home, Receipt, Target, Wallet, Settings, TrendingUp } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { icon: Home, label: 'Home', path: '/' },
  { icon: Receipt, label: 'Transactions', path: '/transactions' },
  { icon: Target, label: 'Budgets', path: '/budgets' },
  { icon: Wallet, label: 'Assets', path: '/assets' },
  { icon: TrendingUp, label: 'Goals', path: '/goals' },
  { icon: Settings, label: 'Settings', path: '/settings' },
];

export default function Navigation() {
  const location = useLocation();

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0 bg-white border-r border-stone-200">
        <div className="flex-1 flex flex-col min-h-0">
          <div className="flex items-center h-16 flex-shrink-0 px-6 border-b border-stone-200">
            <h1 className="text-2xl font-bold font-heading text-green-900">E1 Finance</h1>
          </div>
          <nav className="flex-1 px-4 py-6 space-y-1">
            {navItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              return (
                <Link
                  key={item.path}
                  to={item.path}
                  data-testid={`nav-${item.label.toLowerCase()}`}
                  className={`flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all ${
                    isActive
                      ? 'bg-green-900 text-white shadow-lg'
                      : 'text-stone-600 hover:bg-stone-100 hover:text-stone-900'
                  }`}
                >
                  <Icon className="mr-3 h-5 w-5" strokeWidth={1.5} />
                  {item.label}
                </Link>
              );
            })}
          </nav>
        </div>
      </div>

      {/* Mobile Bottom Navigation */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-stone-200 z-50">
        <nav className="flex justify-around py-2">
          {navItems.slice(0, 5).map((item) => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.path}
                to={item.path}
                data-testid={`mobile-nav-${item.label.toLowerCase()}`}
                className={`flex flex-col items-center justify-center px-3 py-2 text-xs font-medium rounded-lg transition-colors ${
                  isActive ? 'text-green-900' : 'text-stone-500'
                }`}
              >
                <Icon className="h-5 w-5 mb-1" strokeWidth={1.5} />
                {item.label}
              </Link>
            );
          })}
        </nav>
      </div>
    </>
  );
}
